import { render, staticRenderFns } from "./index02.vue?vue&type=template&id=4c05b78e&scoped=true&"
import script from "./index02.vue?vue&type=script&lang=js&"
export * from "./index02.vue?vue&type=script&lang=js&"
import style0 from "./index02.vue?vue&type=style&index=0&id=4c05b78e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05b78e",
  null
  
)

export default component.exports